import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  // --- Logica per Importa Dati rimossa ---
  // --- Logica per Salva/Carica Sessione rimossa ---

  return (
    <div
      style={{
        position: 'fixed', // Già fixed, va bene
        top: 0, // Fissato in alto
        left: 0, // Allineato a sinistra
        color: 'var(--color-text-light)',
        width: '100%', // Larghezza piena
        height: '40px', // Manteniamo l'altezza fissa per ora
        borderRadius: '0', // Rimosso border radius per allineamento bordi
        zIndex: 'var(--z-index-header)', // Già presente, va bene
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--spacing-xl)',
        boxSizing: 'border-box',
        backgroundColor: 'var(--color-background-dark)', // Aggiunto sfondo per visibilità
      }}
    >
      {/* Logo e brand a sinistra */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-s)' }}>
        <img 
          src="/logo.svg" 
          alt="Michele Tricarico Logo" 
          style={{ 
            width: '24px', 
            height: '24px',
            opacity: 0.9
          }} 
        />
        <span style={{
          color: 'var(--color-text-light)',
          fontSize: 'var(--font-size-base)',
          fontFamily: 'var(--font-family-base)',
          fontWeight: 'var(--font-weight-medium)',
          opacity: 0.9
        }}>
          The Map Editor
        </span>
      </div>

      {/* Crediti centrati */}
      <div style={{ 
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--spacing-s)' 
      }}>
        <span style={{
          color: 'var(--color-text-light)',
          fontSize: 'var(--font-size-small)',
          fontFamily: 'var(--font-family-base)',
          opacity: 0.7
        }}>
          © 2025 
        </span>
        <a 
          href="https://micheletricarico.com" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#4CAF50',
            textDecoration: 'none',
            fontSize: 'var(--font-size-small)',
            fontFamily: 'var(--font-family-base)',
            fontWeight: 'var(--font-weight-medium)',
            opacity: 0.9,
            transition: 'all 0.2s ease-in-out'
          }}
          onMouseEnter={(e) => {
            const target = e.target as HTMLAnchorElement;
            target.style.opacity = '1';
            target.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            const target = e.target as HTMLAnchorElement;
            target.style.opacity = '0.9';
            target.style.textDecoration = 'none';
          }}
        >
          Michele Tricarico
        </a>
        <span style={{
          color: 'var(--color-text-light)',
          fontSize: 'var(--font-size-small)',
          fontFamily: 'var(--font-family-base)',
          opacity: 0.7
        }}>
          - A lot of AI Agents (mostly ClaudeCode and Gemini) were harmed during the development of this app.
        </span>
      </div>

      {/* Info link a destra */}
      <div>
        <button
          onClick={() => setIsInfoModalOpen(true)}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--color-text-light)',
            fontSize: 'var(--font-size-small)',
            fontFamily: 'var(--font-family-base)',
            cursor: 'pointer',
            opacity: 0.8,
            transition: 'opacity 0.2s ease-in-out',
            textDecoration: 'underline'
          }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
        >
          Info about this project
        </button>
      </div>

      {/* Modal Info */}
      {isInfoModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--spacing-xl)'
        }}>
          <div style={{
            backgroundColor: 'var(--color-background-ui)',
            borderRadius: 'var(--border-radius-large)',
            padding: 'var(--spacing-xl)',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflow: 'auto',
            color: 'var(--color-text-light)',
            fontFamily: 'var(--font-family-base)',
            position: 'relative'
          }}>
            <button
              onClick={() => setIsInfoModalOpen(false)}
              style={{
                position: 'absolute',
                top: 'var(--spacing-m)',
                right: 'var(--spacing-m)',
                background: 'none',
                border: 'none',
                color: 'var(--color-text-light)',
                fontSize: '24px',
                cursor: 'pointer',
                opacity: 0.7
              }}
            >
              ×
            </button>

            <h2 style={{ marginTop: 0, color: '#4CAF50' }}>The Map Editor - Project Information</h2>
                        
            <div style={{
              backgroundColor: 'rgba(255, 193, 7, 0.1)',
              border: '1px solid #FFC107',
              borderRadius: 'var(--border-radius-medium)',
              padding: 'var(--spacing-m)',
              marginBottom: 'var(--spacing-l)'
            }}>
              <p><strong>⚡ Hobby Project Notice:</strong></p>
              <p>This application is developed as a <strong>hobby project</strong> for learning and experimentation purposes. It is <strong>NOT intended for production use</strong> or critical business applications.</p>
              
              <p><strong>🚫 No Warranty & Liability:</strong></p>
              <ul style={{ marginBottom: 0 }}>
                <li>The author provides this software "as is" without any warranties</li>
                <li>No guarantee of data integrity, accuracy, or application stability</li>
                <li>Use at your own risk - the author assumes no responsibility for any data loss, damages, or consequences arising from the use of this application</li>
                <li>Not suitable for professional GIS workflows or mission-critical operations</li>
              </ul>
            </div>

            <h3>🎯 Purpose & Target Audience</h3>
            <p>This is a sophisticated web-based geospatial map editor and visualization application designed for GIS professionals, researchers, developers, and educators who need powerful map editing capabilities with advanced styling options directly in the browser.</p>
            
            <h3>🛠️ Technology Stack</h3>
            <ul>
              <li><strong>Frontend:</strong> React 19 with TypeScript</li>
              <li><strong>Build Tool:</strong> Vite for fast development and optimized builds</li>
              <li><strong>Mapping Engine:</strong> MapLibre GL JS (open-source alternative to Mapbox GL JS)</li>
              <li><strong>State Management:</strong> Zustand with slice pattern</li>
              <li><strong>Styling:</strong> CSS Modules for component-scoped styling</li>
              <li><strong>Geospatial Processing:</strong> Turf.js, Shapefile.js, Proj4</li>
              <li><strong>Data Visualization:</strong> Recharts, D3-contour</li>
              <li><strong>Drawing Tools:</strong> Terra Draw for map interaction</li>
            </ul>

            <h3>✨ Core Features</h3>
            <ul>
              <li><strong>Multi-format import:</strong> GeoJSON, Shapefile, CSV, GPX, KML</li>
              <li><strong>Advanced styling:</strong> Visual editor with MapLibre expressions</li>
              <li><strong>3D visualization:</strong> Terrain and globe projection support</li>
              <li><strong>Data analysis:</strong> Attribute tables, charts, elevation contours</li>
              <li><strong>Drawing tools:</strong> Create and edit vector geometries</li>
              <li><strong>Export capabilities:</strong> Multiple formats including PNG, PDF, GeoJSON</li>
              <li><strong>Interactive basemaps:</strong> OpenStreetMap variants, satellite imagery</li>
            </ul>

            <h3>📁 Supported Data Sources & Formats</h3>
            
            <h4>Import Support Matrix:</h4>
            <div style={{
              overflowX: 'auto',
              marginBottom: 'var(--spacing-m)'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: 'var(--font-size-small)',
                backgroundColor: 'var(--color-background-ui)',
                border: '1px solid var(--color-border-subtle)'
              }}>
                <thead>
                  <tr style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)' }}>
                    <th style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'left' }}>Format</th>
                    <th style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center' }}>Local Files</th>
                    <th style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center' }}>Remote URLs</th>
                    <th style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'left' }}>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>GeoJSON</strong> (.json, .geojson)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Full support with automatic bounds calculation</td>
                  </tr>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>Shapefile</strong> (.zip)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Complete archives with SHP, SHX, DBF, PRJ files</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>CSV</strong> (.csv)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Lat/Lon, WKT geometry, DMS format support</td>
                  </tr>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>GPX</strong> (.gpx)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>GPS tracks, routes, and waypoints</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>KML</strong> (.kml)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Google Earth format with styling and folders</td>
                  </tr>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>PMTiles</strong> (.pmtiles)</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Cloud-optimized with metadata discovery</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>TileJSON</strong></td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Vector & raster tile metadata specifications</td>
                  </tr>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>XYZ Vector Tiles</strong></td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Template URLs with source layer configuration</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>XYZ Raster Tiles</strong></td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>Standard web map tiles and custom endpoints</td>
                  </tr>
                  <tr style={{ backgroundColor: 'rgba(255, 255, 255, 0.02)' }}>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>WMS Services</strong> *</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>GetCapabilities parsing with bounds extraction</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}><strong>COG (Cloud Optimized GeoTIFF)</strong></td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#f44336' }}>❌</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)', textAlign: 'center', color: '#4CAF50' }}>✅</td>
                    <td style={{ padding: '8px', border: '1px solid var(--color-border-subtle)' }}>With CRS transformation and DEM support</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p style={{
              fontSize: 'var(--font-size-small)',
              fontStyle: 'italic',
              color: 'var(--color-text-secondary)',
              marginBottom: 'var(--spacing-m)'
            }}>
              * Formats marked with asterisk have experimental support and may be subject to bugs or limitations.
            </p>
            
            <h4>Export Formats:</h4>
            <ul>
              <li><strong>Vector data:</strong> GeoJSON, Shapefile, CSV with coordinates</li>
              <li><strong>Styling:</strong> MapLibre Style JSON for complete style preservation</li>
              <li><strong>Images:</strong> High-resolution PNG and PDF maps with custom DPI</li>
              <li><strong>Print-ready:</strong> PDF generation with custom page sizes and margins</li>
            </ul>

            <h3>⚠️ Known Limitations</h3>
            <ul>
              <li>Some MapLibre properties (line-dasharray, line-pattern) have limited support</li>
              <li>Large files may impact performance</li>
              <li>Requires modern browsers with WebGL support</li>
              <li>Primarily optimized for desktop use</li>
              <li>Limited offline capabilities</li>
            </ul>

            <h3>🏗️ Architecture Highlights</h3>
            <ul>
              <li><strong>Performance optimized:</strong> Code splitting, lazy loading, virtualization</li>
              <li><strong>Modular state management:</strong> Separate Zustand slices for different concerns</li>
              <li><strong>Feature-based organization:</strong> Clean separation with TypeScript interfaces</li>
              <li><strong>Web Workers:</strong> Background processing for file operations</li>
            </ul>

            <h3>👨‍💻 Development</h3>
            <p>Built with modern web technologies focusing on performance, type safety, and user experience. The application combines powerful GIS capabilities with an intuitive interface for comprehensive geospatial data management.</p>
          </div>
        </div>
      )}

      {/* Input e Dialog rimossi */}
    </div>
  );
};

export default Header;